import { getFormFormattedDate } from 'utils'

import { formatAmount } from 'utils'

import { FundingRound } from './types'

export const displayCurrentFundingRound = (
  { targetMoney, targetMoneyCurrency, roundType }: FundingRound = {} as any
) => {
  const targetMoneyLabel = targetMoney ? formatAmount(targetMoney, targetMoneyCurrency) : 'funds'
  const roundTypeLabel = roundType ? ` (${roundType})` : ''
  return !!targetMoney || !!roundType ? `Currently raising ${targetMoneyLabel}${roundTypeLabel}` : ''
}

export const displayValuationPreMoney = ({ valuationPreMoney, valuationPreMoneyCurrency }: FundingRound = {} as any) =>
  !!valuationPreMoney ? `Pre-money valuation of ${formatAmount(valuationPreMoney, valuationPreMoneyCurrency)}` : ''

export const displayTargetMoney = ({ targetMoney, targetMoneyCurrency }: FundingRound = {} as any) =>
  !!targetMoney ? `Target money of ${formatAmount(targetMoney, targetMoneyCurrency)}` : ''

export const displayRoundTerms = ({ roundTerms }: FundingRound = {} as any) =>
  !!roundTerms ? `Round terms: ${roundTerms}` : ''

export const displayCommittedInvestors = ({ committedInvestors }: FundingRound = {} as any) =>
  !!committedInvestors ? `Committed Investors: ${committedInvestors}` : ''

let temporalFundingRound = 0
export function newFundingRound() {
  temporalFundingRound--
  return {
    id: temporalFundingRound,
    roundType: '',
    announcedOn: getFormFormattedDate(),
    roundSize: '',
    targetMoney: '',
    valuationPreMoney: '',
    roundTerms: '',
    committedInvestors: '',
    investments: [],
    toDelete: false,
  }
}
